<template>
    <div>
            <div class="row">
                <label for="framesready" class="termslabel lp">
                    <input v-model="sampleobject.acceptedTerms" id="framesready" name="Frames ready" v-validate="isRequired" type="checkbox" class="termscheck"> I have my frames ready to ship to the lab for processing.
                </label>
                <div :class="{'error': errors.has('Frames ready') }">
                    <p class="error" v-if="errors.has('Frames ready')">It is important not to submit the Evaluation Product job until you have your frames ready to ship. This will reduce delays in matching the job with the correct frame.</p>
                </div>
            </div>
            <div class="row">
                <div class="medium-4 columns lp">
                    <labeled-input validation="required|max:20" label="Frame Manufacturer *" name="Frame Manufacturer" v-model='sampleobject.manufacturer'></labeled-input>
                </div>
                <div class="medium-4 columns lp">
                    <labeled-input validation="required|max:50" label="Frame Model *" name="Frame Model" v-model='sampleobject.model'></labeled-input>
                </div>
                <div class="medium-4 columns lp">
                    <labeled-input validation="required|max:50" label="Frame Color *" name="Frame Color" v-model='sampleobject.color'></labeled-input>
                </div>
            </div>
            <div class="row">
                <div class="medium-4 columns lp">
                    <div :class="{'error': errors.has('Frame Type') }">
                        <label for="frame_Type">Frame Type *</label>
                        <select v-validate data-vv-rules="required" v-model="sampleobject.type" name="Frame Type" id="frame_Type" class="orderinput-select">
                            <!-- <option selected value> </option> -->
                            <option value="ZYL">Zyl Edge</option>
                            <option value="METAL">Metal Edge</option>
                            <option value="DRILL">Drilled Rimless</option>
                            <option value="DRILL2">Drill 2 Holes</option>
                            <option value="DRILL4">Drill 4 Holes</option>
                            <option value="DRILL6">Drill 6 Holes</option>
                            <option value="DRILL8">Drill 8 Holes</option>
                            <option value="GROOVE">Grooved Rimless</option>
                            <option value="FACET">Facet Edge</option>
                            <option value="MHALF">1/2 Eye Metal</option>
                            <option value="HALF">1/2 Eye Zyl</option>
                            <option value="FULL">Full Metal Groove</option>
                        </select>
                        <p class="error" v-if="errors.has('Frame Type')">{{ errors.first('Frame Type') }}</p>
                    </div>
                </div>
                <div class="medium-2 columns lp">
                    <labeled-input autocomplete="off" validation="required|numeric" label="Temple Length *" name="Temple Length" v-model='sampleobject.templeLength'></labeled-input>
                </div>
                <div class="medium-2 columns lp">
                    <labeled-input autocomplete="off" validation="required|decimal:0|between:10,80" label="A Box*" name="A Box" v-model='sampleobject.aBox'></labeled-input>
                </div>
                <div class="medium-2 columns lp">
                    <labeled-input autocomplete="off" validation="required|decimal:0|between:10,80" label="B Box*" name="B Box" v-model='sampleobject.bBox'></labeled-input>
                </div>
                <div class="medium-2 columns lp">
                    <labeled-input autocomplete="off" validation="required|decimal:0|between:0,35" label="DBL*" name="DBL" v-model='sampleobject.dbl'></labeled-input>
                </div>
            </div>


            <div class="row" v-if="program.allowUncut">
                <div class="columns small-12 lp">
                    <label for="allowUncut" class="small-text"> <input v-model="sampleobject.uncut" id="allowUncut" name="Allow uncut" type="checkbox">
                        <strong>I would like to order uncut lenses.</strong>
                    </label>
                    <p v-show="sampleobject.uncut" class="small-text">I would like to order uncut lenses. I understand that I will have to edge and mount these on my own, and confirm that my location has the ability and know-how to do so. I understand that I will not have the ability to have my lenses remade in the event that the process is done incorrectly. The Rx, Measurement, and Frame Information I have entered is correct and accurate.</p>
                </div>
            </div>
            
    </div>
</template>
<script>
import LabeledInput from "@/components/shared/LabeledInput";
export default {
  props: ["sampleobject", "program"],
  inject: ["$validator"],
  components: { LabeledInput },
  computed: {
      isRequired() {
          // When uncut is checked, frames ready field is not required
          return (this.sampleobject.uncut) ? '' : 'required'; 
      }
  }
};
</script>